import { type Guard, type GuardStatus } from '@capsicum/common';
import { privateKeyHexAtom } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export const ExportPrivateKeyGuard: Guard = () => {
	const privateKeyHex = useAtomValue(privateKeyHexAtom);
	const [status, setStatus] = useState<GuardStatus>('loading');
	const { replace } = useRouter();

	const onDenied = () => replace('/login');

	useEffect(() => {
		setStatus(privateKeyHex ? 'allowed' : 'denied');
	}, [privateKeyHex]);

	return {
		onDenied,
		status
	};
};
